import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "tti_recent_searches";
const MAX_RECENT = 5;

function readStored() {
  try {
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    return Array.isArray(stored) ? stored : [];
  } catch {
    return [];
  }
}

export function useRecentSearches() {
  const [recent, setRecent] = useState(readStored);

  useEffect(() => {
    setRecent(readStored());
  }, []);

  const addSearch = useCallback((query) => {
    const q = query.trim();
    if (!q) return;
    setRecent((prev) => {
      const next = [q, ...prev.filter((x) => x.toLowerCase() !== q.toLowerCase())].slice(0, MAX_RECENT);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      return next;
    });
  }, []);

  const removeSearch = useCallback((query) => {
    setRecent((prev) => {
      const next = prev.filter((x) => x !== query);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      return next;
    });
  }, []);

  return { recent, addSearch, removeSearch };
}
